import React from 'react';
export function NotAllowedIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.016 2H12a10 10 0 00-.016 20H12a10 10 0 00.015-20zM12 4h.012a7.956 7.956 0 014.895 1.7L5.677 16.891A7.992 7.992 0 0112 4zm5.647 13.665A7.94 7.94 0 0112 20h-.013a7.938 7.938 0 01-4.9-1.692l11.229-11.2a7.974 7.974 0 01-.672 10.553l.003.004z"
  }));
}